import React from "react";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const ActivationChart = ({ dayWiseData }) => {
	const chartData = dayWiseData.map(day => ({
		day: day.day,
		activationRate: parseFloat(day.partner_earnings.activation_rate),
		earners: day.partner_earnings.total_earners,
		withdrawalRate: parseFloat(day.withdrawals.withdrawal_rate)
	}));

	return (
		<div>
			<div style={{ marginBottom: "20px" }}>
				<h3 style={{ margin: "0 0 4px 0", fontSize: "18px", fontWeight: "700", color: "#1F2937" }}>
					📈 Activation & Withdrawal Trends (D0-D15)
				</h3>
				<p style={{ margin: 0, fontSize: "13px", color: "var(--text-muted)" }}>
					Daily activation rate and withdrawal behavior over first 16 days
				</p>
			</div>

			<ResponsiveContainer width="100%" height={350}>
				<LineChart data={chartData} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
					<CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" />
					<XAxis
						dataKey="day"
						stroke="#6B7280"
						style={{ fontSize: "12px" }}
					/>
					<YAxis
						stroke="#6B7280"
						style={{ fontSize: "12px" }}
						label={{ value: 'Rate (%)', angle: -90, position: 'insideLeft', style: { fontSize: "12px" } }}
					/>
					<Tooltip
						contentStyle={{
							backgroundColor: "white",
							border: "1px solid #E5E7EB",
							borderRadius: "8px",
							boxShadow: "0 4px 6px rgba(0,0,0,0.1)"
						}}
						formatter={(value, name) => {
							if (name === "Activation Rate") return `${value.toFixed(2)}%`;
							if (name === "Withdrawal Rate") return `${value.toFixed(2)}%`;
							return value;
						}}
					/>
					<Legend
						wrapperStyle={{ fontSize: "13px", paddingTop: "10px" }}
					/>
					<Line
						type="monotone"
						dataKey="activationRate"
						stroke="#3B82F6"
						strokeWidth={3}
						name="Activation Rate"
						dot={{ fill: "#3B82F6", r: 4 }}
						activeDot={{ r: 6 }}
					/>
					<Line
						type="monotone"
						dataKey="withdrawalRate"
						stroke="#8B5CF6"
						strokeWidth={3}
						name="Withdrawal Rate"
						dot={{ fill: "#8B5CF6", r: 4 }}
						activeDot={{ r: 6 }}
					/>
				</LineChart>
			</ResponsiveContainer>

			{/* Key Insights */}
			<div style={{
				marginTop: "20px",
				padding: "16px",
				backgroundColor: "#F9FAFB",
				borderRadius: "8px",
				display: "grid",
				gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
				gap: "12px"
			}}>
				<div>
					<p style={{ margin: "0 0 4px 0", fontSize: "11px", fontWeight: "600", color: "#6B7280", textTransform: "uppercase" }}>
						Peak Activation
					</p>
					<p style={{ margin: 0, fontSize: "18px", fontWeight: "700", color: "#3B82F6" }}>
						{Math.max(...chartData.map(d => d.activationRate)).toFixed(2)}%
					</p>
				</div>
				<div>
					<p style={{ margin: "0 0 4px 0", fontSize: "11px", fontWeight: "600", color: "#6B7280", textTransform: "uppercase" }}>
						D15 Activation
					</p>
					<p style={{ margin: 0, fontSize: "18px", fontWeight: "700", color: "#10B981" }}>
						{chartData[15]?.activationRate.toFixed(2)}%
					</p>
				</div>
				<div>
					<p style={{ margin: "0 0 4px 0", fontSize: "11px", fontWeight: "600", color: "#6B7280", textTransform: "uppercase" }}>
						Peak Withdrawal Day
					</p>
					<p style={{ margin: 0, fontSize: "18px", fontWeight: "700", color: "#8B5CF6" }}>
						{chartData?.reduce(
							(max, d) => d.withdrawalRate > max.withdrawalRate ? d : max,
							{ withdrawalRate: -Infinity, day: "-" }
						)?.day}
					</p>
				</div>
				<div>
					<p style={{ margin: "0 0 4px 0", fontSize: "11px", fontWeight: "600", color: "#6B7280", textTransform: "uppercase" }}>
						Total Active Days
					</p>
					<p style={{ margin: 0, fontSize: "18px", fontWeight: "700", color: "#F59E0B" }}>
						{chartData?.filter(d => d.earners > 0).length} / 16
					</p>
				</div>
			</div>
		</div>
	);
};

export default ActivationChart;